import React from "react";

// Logos — make sure these images exist in /src/assets
import awsLogo from "../assets/aws-logo.png";
import oracleLogo from "../assets/oracle-logo.png";
import courseraLogo from "../assets/coursera-logo.png";
import ibmLogo from "../assets/ibm-logo.png";
import deepLearningLogo from "../assets/deeplearningai-logo.png";
import vanderbiltLogo from "../assets/vanderbilt-logo.png";
import bcgLogo from "../assets/bcg-logo.png";
import britishLogo from "../assets/british-airways-logo.png";
import microsoftLogo from "../assets/microsoft-logo.png";
import nasbaLogo from "../assets/nasba-logo.png";
import unstopLogo from "../assets/unstop-logo.png";
import internshalaLogo from "../assets/internshala-logo.png";

function Certifications() {
  const certs = [
    {
      title: "AWS Educate Machine Learning Foundations - Training Badge",
      issuer: "Amazon Web Services (AWS)",
      date: "Issued Oct 2025",
      logo: awsLogo,
      link: "https://www.credly.com/badges/03892123-a135-44a1-b45e-7a433128674a/linked_in_profile",
    },
    {
      title: "Oracle Cloud Infrastructure 2025 Certified Generative AI Professional",
      issuer: "Oracle",
      date: "Issued Oct 2025 · Expires Oct 2027",
      logo: oracleLogo,
      link: "https://catalog-education.oracle.com/ords/certview/sharebadge?id=DA88D08878EA340DED7789B9DDE2CB9740E6A95FA876A76209BEDBD59FF71DE3",
    },
    {
      title: "Oracle Database@AWS Certified Architect Professional",
      issuer: "Oracle",
      date: "Issued Oct 2025 · Expires Oct 2027",
      logo: oracleLogo,
      link: "https://catalog-education.oracle.com/ords/certview/sharebadge?id=A3A70212C5501C6046E3AA5E3C6D7CB5E6016278E02961440CACC0C85CF0017E",
    },
    {
      title: "Oracle Cloud Infrastructure 2025 Certified Data Science Professional",
      issuer: "Oracle",
      date: "Issued Sep 2025 · Expires Sep 2027",
      logo: oracleLogo,
      link: "https://catalog-education.oracle.com/ords/certview/sharebadge?id=ACAACE077BD81A2993D330134CBC8375210DD1C34035C357394879AD81E3C02A",
    },
    {
      title: "Oracle Cloud Infrastructure 2025 Certified AI Foundations Associate",
      issuer: "Oracle",
      date: "Issued Sep 2025 · Expires Sep 2027",
      logo: oracleLogo,
      link: "https://catalog-education.oracle.com/ords/certview/sharebadge?id=A3418B6C6AF4788A3337100EEEA6018667767A7C144874EBBC36A2D99F6B72D0",
    },
    {
      title: "ChatGPT Prompt Engineering for Developers",
      issuer: "DeepLearning.AI",
      date: "Issued Sep 2025",
      logo: deepLearningLogo,
      link: "https://learn.deeplearning.ai/accomplishments/f4b299ed-b8de-405f-9bb2-3af04733b5c3?usp=sharing",
    },
    {
      title: "Prompt Engineering for ChatGPT",
      issuer: "Vanderbilt University",
      date: "Issued Sep 2025",
      logo: vanderbiltLogo,
      link: "https://www.coursera.org/account/accomplishments/verify/RRBKG33J7CI5",
    },
    {
      title: "IBM Data Science",
      issuer: "IBM",
      date: "Issued Sep 2025",
      logo: ibmLogo,
      link: "https://www.coursera.org/account/accomplishments/professional-cert/4XCH7JYSX1YH",
    },
    {
      title: "Machine Learning with Python (V2)",
      issuer: "Coursera",
      date: "Issued Sep 2025",
      logo: courseraLogo,
      link: "https://www.credly.com/badges/a9467703-8beb-4fba-bad2-df283c34df85/linked_in_profile",
    },
    {
      title: "BCG - Data Science Job Simulation",
      issuer: "BCG X",
      date: "Issued Aug 2025",
      logo: bcgLogo,
      link: "https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/SKZxezskWgmFjRvj9/Tcz8gTtprzAS4xSoK_SKZxezskWgmFjRvj9_JmcNSWZe8ohBTozTb_1754844101895_completion_certificate.pdf",
    },
    {
      title: "British Airways - Data Science Job Simulation",
      issuer: "British Airways",
      date: "Issued Aug 2025",
      logo: britishLogo,
      link: "https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/tMjbs76F526fF5v3G/NjynCWzGSaWXQCxSX_tMjbs76F526fF5v3G_JmcNSWZe8ohBTozTb_1756033088049_completion_certificate.pdf",
    },
    {
      title: "Blockchain Basics",
      issuer: "National Association of State Boards of Accountancy (NASBA)",
      date: "Issued Aug 2023",
      logo: nasbaLogo,
      link: "https://www.linkedin.com/learning/certificates/b9aaaf1cfc212600140198ec695bcdbea6acb7df9044f05e2094acf295eb5b97",
    },
    {
      title: "Blockchain: Beyond the Basics",
      issuer: "NASBA",
      date: "Issued Aug 2023",
      logo: nasbaLogo,
      link: "https://www.linkedin.com/learning/certificates/2b908575968640a5af8b382069e1c3854e49c617cb8063cff863aaae7219075b",
    },
    {
      title: "Career Essentials in Generative AI",
      issuer: "Microsoft",
      date: "Issued Aug 2023",
      logo: microsoftLogo,
      link: "https://www.linkedin.com/learning/certificates/f17123bc48869947ac7af08c666c30b03da5bf45c6194f2b64e205dcd2ed6589",
    },
    {
      title: "30 Days DSA Bootcamp",
      issuer: "Unstop",
      date: "Issued Jul 2025",
      logo: unstopLogo,
      link: "https://unstop.com/certificate-preview/d540d44d-bfc3-40a4-a5b0-e6561d08f1e0",
    },
    {
      title: "Financial Modeling and Valuation",
      issuer: "Internshala",
      date: "Issued Oct 2023",
      logo: internshalaLogo,
      link: "https://trainings.internshala.com/view_certificate/67kncrw06sy/7mlgr9cx8n0/",
    },
  ];

  return (
    <div className="section-content certifications-section">
      <h1>Certifications</h1>
      <p className="section-intro">
        A portfolio of credentials highlighting my expertise in Data Science,
        Cloud Computing, Artificial Intelligence, and Software Development.
      </p>

      <div className="cert-grid">
        {certs.map((cert) => (
          <a
            href={cert.link}
            key={cert.title}
            target="_blank"
            rel="noopener noreferrer"
            className="cert-card"
          >
            {cert.logo && (
              <img src={cert.logo} alt={cert.issuer} className="cert-logo" />
            )}
            <h3 className="cert-title">{cert.title}</h3>
            <p className="cert-issuer">{cert.issuer}</p>
            <p className="cert-date">{cert.date}</p>
            <span className="cert-link">View Credential →</span>
          </a>
        ))}
      </div>
    </div>
  );
}

export default Certifications;
